export const WebsiteRoot = 'https://messinismarios.com/';

export const pageTransition = {duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]};
export const pageTransitionInstant = {duration: 0, delay: 1.3, ease: 'linear'};
export const pageTransitionSlow = {duration: 1.4, ease: [0.6, 0.01, 0.15, 0.97]};

export const pageTransitionDelay = {duration: 0, delay: 0.6};
export const pageTransitionSlowDelay = {duration: 0, delay: 1.4};
